import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components'
import Spinner from 'spinner';
import Box from 'components/box';
import Input from 'form/input';
import Textarea from 'form/textarea';
import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import Upload from 'components/upload'
import {PageHead} from 'components/header/components';
import {ButtonDefault} from 'components/buttons';
import {Label, Divider, SelectWithSearch, SelectWithSearchAsync} from 'components/common';
import {changeInstitutionValue, submitNewInstitution, institutionCleanStore, loadInstitutionDetail, searchTypes, attachFile, loadInstitutionsByLevelExeptLast, onCleanParent, loadInstitutionDetailAfterSearch, onLoadParentByParentProperty} from 'redux/actions/admin/institution';

import {MaskedInput} from 'components/common';

import close from 'images/general/close.svg';


const UploadWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

const mapStateToProps = (state) => ({

  institutionsByLevelExeptLast: state.adminInstitution.get('institutionsByLevelExeptLast'),
  istitutionsByLevelExeptLastIsLoading: state.adminInstitution.get('istitutionsByLevelExeptLastIsLoading'),

  newInstitutionDetail: state.adminInstitution.get('newInstitutionItem'),

  institutionParent: state.adminInstitution.get('institutionParent'),
  parentByParentIsLoading: state.adminInstitution.get('loadParentByParentPropertyIsLoading'),

  institutionDetail: state.adminInstitution.get('institutionItem'),
  isFetching: state.institutions.get('institutionsIsLoading'),

  institutionsByLevel: state.adminInstitution.get('institutionsByLevel'),
  institutionsByLevelAreLoading: state.adminInstitution.get('institutionsByLevelAreLoading'),

  item: state.adminInstitution.get('institutionItem'),
  photo: state.adminInstitution.get('photo'),
  isSubmitting: state.adminInstitution.get('institutionIsSubmitting'),
  hasError: state.adminInstitution.get('institutionCreateFailed'),
}); 

const mapDispatchToProps = (dispatch) => ({
  onValueChange: (value, key) => dispatch(changeInstitutionValue(value, key)),
  attachFile: (file) => dispatch(attachFile(file)),
  onMount: (id) => dispatch(loadInstitutionDetail(id)),
  onChooseParent: (id) => dispatch(loadInstitutionDetailAfterSearch(id)),
  onLoadInstByLevel: (offset, search) => dispatch(loadInstitutionsByLevelExeptLast(100, offset, search)),

  onSubmit: (event, institution_id, parentId, parentFromLocation) => {
    event.preventDefault();
    dispatch(submitNewInstitution('/admin/institutions/detail/', institution_id, parentId, parentFromLocation))
  },
  onClean: () => {
    dispatch(institutionCleanStore())
    dispatch(onCleanParent())
  },
  onSearchTypes: (parent) => dispatch(searchTypes(parent)),

  onLoadParentByParentProperty: (parent) => dispatch(onLoadParentByParentProperty(parent))

});



class CreateInstitution extends Component {

  state = {
    currentInstType: '',
    parentId: this.props.location.state !== undefined ? this.props.location.state.institution : '',
    parentType: '',
    geographicPosition: '',
    address: '',
    parentSelect: '',
    modalOpen: false
  }

  selectWithSearchStyle = {
    border: 'none'
  }

  selectWithSearchStyleDisabled = {
    border: 'none',
    opacity: 0.5
  }

  onChangeParent = parent => {
    if(!parent) parent =  { value: '' }
    this.setState({
      parentId: parent.value,
      parentType : parent.type,
      parentSelect: parent,
      short: ''
    })
    this.props.onChooseParent(parent.value);

    this.props.onSearchTypes(parent.type);
  }

  onChangeLocation = (e) => {
    this.setState({
      geographicPosition: e.target.value
    })
    this.props.onValueChange(e.target.value, 'geographic_position')
  }

  toggleOpen = () => {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}


	toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

	onModalOk = () => {
	  this.toggleModal()
	  this.props.history.goBack()
	}

  onChangeType = (type) => {
    if(!type) type =  { type: '' }
    this.setState({
      currentInstType: type.value
    })
      this.props.onValueChange(type.value, "institution_type")
  }

  generateTypeOptions () {
    if(this.props.institutionsByLevel.get('results')) {
      return this.props.institutionsByLevel.get('results').reduce((arr, item) => {
        const newOption = {value: item.get('code'), label: `${item.get('code')} ${item.get('title')}`}
        return arr = [...arr, newOption]
      }, [])
    } else {
      return []
    }
  }

  generateParentOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), type: item.get('institution_type'), label: item.get('full_title') }
      arr.push(newOption)
      return arr
    }, [])
  }

  loadParent = (search = '') => {
    return this.props.onLoadInstByLevel('', search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateParentOptions(results)
        return { options }
      })
  }

   componentDidMount() {
    this.props.onLoadInstByLevel();
    if (this.props.match.params.institution_id) {
    this.props.onMount(this.props.match.params.institution_id)
      .then(() => {
        return this.props.onLoadParentByParentProperty(this.props.institutionDetail.get('parent'))

      })
      .then((data) => {

        this.props.onSearchTypes(this.props.institutionParent.get('institution_type'))
      })

    }else if (this.props.location.state && this.props.location.state.instType){
        this.props.onSearchTypes(this.props.location.state.instType)
        this.props.onClean();
                
    }

    else {
      this.props.onClean();
      this.props.onSearchTypes()
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.institutionParent.get('institution_type')){
      this.setState(() => ({
        parentId: nextProps.institutionParent.get('id'),
        parentType: nextProps.institutionParent.get('institution_type')
      }))
    }
  }

  componentWillUnmount(){
    this.props.onClean()
  }

  render() {

    if (!this.props.institutionsByLevel) return <Spinner/>;

      const item = this.props.institutionDetail;

      const chooseSelect = () => {
        if (this.props.location.state !== undefined){
          return (
              <Divider>
                  <Label>Установа верхнього рівня:</Label>
                  <SelectWithSearch
                      isDisabled={true}
                      disabled={true}
                      required
                      value={this.props.location.state.institution}
                      style={this.selectWithSearchStyle}
                      placeholder={this.props.location.state.institution_title}
                      noResultsText="Немає результатів"
                  />
              </Divider>
          )
        } else if (this.props.match.params.institution_id !== undefined){
            return (
                <Divider>
                    <Label>Установа верхнього рівня:</Label>
                    <SelectWithSearch
                        isDisabled={true}
                        disabled={true}
                        required
                        value={this.props.institutionParent.get('id')}
                        style={ this.selectWithSearchStyle }
                        placeholder={this.props.institutionParent.get('full_title') || "Відсутня"}
                        noResultsText="Немає результатів"
                    />
                </Divider>
            )
        } else {
          return (
              <Divider>
                <Label>Установа верхнього рівня:<span style={{color: "#edbd2f"}}> *</span></Label>
                  <SelectWithSearchAsync
                    isSearchable={true}
                    searchable={true}
                    required
                    onChange={this.onChangeParent}
                    value={this.state.parentSelect}
                    loadOptions={this.loadParent}
                    valueKey={'value'}
                    labelkey={'label'}
                    style={ this.selectWithSearchStyle }
                    placeholder="Починайте вводити для пошуку..."
                    noResultsText="Немає результатів"
                  />
              </Divider>
          )
        }
      }

      const chooseType = () =>{
          if (this.props.location.state !== undefined){
              return (
                  <Divider>
                      <Label>Тип установи:<span style={{color: "#edbd2f"}}> *</span></Label>
                      <SelectWithSearch
                          options={this.generateTypeOptions()}
                          searchable={true}
                          isSearchable={true}
                          required
                          value={this.props.institutionDetail.get('institution_type')}
                          onChange={this.onChangeType}
                          style={ this.selectWithSearchStyle }
                          placeholder="Тип установи"
                          noResultsText="Немає результатів"
                      />
                  </Divider>
              )
          } else if ((this.props.match.params.institution_id !== undefined) && (this.props.institutionDetail.get('subordinate_institutions') === true)){
              return (
                  <Divider>
                      <Label>Тип установи:</Label>
                      <SelectWithSearch
                          options={this.generateTypeOptions()}
                          isDisabled={true}
                          disabled={true}
                          value={this.props.institutionDetail.get('institution_type')}
                          style={ this.selectWithSearchStyleDisabled }
                          noResultsText="Немає результатів"
                      />
                  </Divider>
              )
          } else if (this.props.match.params.institution_id !== undefined){
            return (
                <Divider>
                    <Label>Тип установи:<span style={{color: "#edbd2f"}}> *</span></Label>
                    <SelectWithSearch
                        options={this.generateTypeOptions()}
                        required
                        isSearchable={true}
                        value={this.props.institutionDetail.get('institution_type')}
                        onChange={this.onChangeType}
                        style={ this.selectWithSearchStyle }
                        placeholder={this.props.institutionDetail.get('full_title')}
                        noResultsText="Немає результатів"
                    />
                </Divider>
            )
        }else {
              return (
                  <Divider>
                      <Label>Тип установи:<span style={{color: "#edbd2f"}}> *</span></Label>
                      <SelectWithSearch
                          options={this.generateTypeOptions()}
                          searchable={true}
                          required
                          isSearchable={true}
                          value={this.state.currentInstType}
                          onChange={this.onChangeType}
                          style={ this.selectWithSearchStyle }
                          placeholder="Тип установи"
                          noResultsText="Немає результатів"
                      />
                  </Divider>
              )
          }
      }

    return (
      <div>
        <PageHead>

          <h2>{this.props.match.params.institution_id ? "Редагувати установу" : "Cтворити установу"}</h2>
        </PageHead>
        <Box title4={this.props.match.params.institution_id ? "Форма редагування установи" : "Форма створення установи"}>
          <form onSubmit={(event) => this.props.onSubmit(event, this.props.match.params.institution_id, this.state.parentId, (this.props.location.state ? this.props.location.state.institution : ''))}>
              {chooseSelect()}

              {chooseType()}

            <Input
              type="text"
              label="Повна назва"
              required
              max="200"
              placeholder="Введіть повну назву"
              value={item.get('full_title') ? item.get('full_title'): ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'full_title')}
            />

            <Input
              type="text"
              required
              max="100"
              label="Коротка назва"
              placeholder="Введіть коротку назву"
              value={item.get('short_title') ? item.get('short_title'): ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'short_title')}
            />

            <Input
              type="text"
              pattern="^(\d{8})$"
              required
                max="8"
              label="ЄДРПОУ код"
              placeholder="Введіть восьмизначний код ЄДРПОУ"
              value={item.get('edrpou_code') ? item.get('edrpou_code'): ''}
              onChange={(event) =>  this.props.onValueChange(event.target.value, 'edrpou_code')}
            />

             <Input
              type="text"
              label="КОАТУУ код"
              pattern="^(\d{10})$"
              required
              max="10"
              placeholder="Введіть десятизначний код КОАТУУ"
              value={item.get('koatuu_code') ? item.get('koatuu_code'): ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'koatuu_code')}
            />

             <Input
              type="text"
              label="Адреса"
              required
              max="100"
              placeholder="Введіть адресу"
              value={item.get('address') ? item.get('address'): ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'address')}
            />
            <Label>Географічні координати</Label>
            <MaskedInput mask="11,111111 11,111111" name="geographic_position" size="17"  onChange={this.onChangeLocation}
             value={item.get('geographic_position') ? item.get('geographic_position'): ''}
             label="Географічні координати"
             placeholder="50.453768, 30.474572"
            />

             <Textarea
              type="text"
              max="2000"
              label="Опис діяльності"
              placeholder="Введіть опис діяльності "
              value={item.get('description') ? item.get('description'): ''}
              onChange={(event) => this.props.onValueChange(event.target.value, 'description')}
            />

              <UploadWrapper>
              <Upload
                loadImage 
                label="Дoдати фото"
                accept=".png, .jpg, .jpeg, .gif"
                onChange={this.props.attachFile}
                file={item.get('photo') ? item.get('photo'): ""}
              />
            </UploadWrapper>


            {this.props.isSubmitting ? (
              <ButtonDefault disabled type="submit" value="Зберегти"/>
            ):(
              <ButtonDefault type="submit" value="Зберегти"/>
            )
          }
           <ButtonDefault onClick={this.toggleModal} value="Вийти без збереження"/>
          </form>
        </Box>

          <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
      </div>
    )
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateInstitution);


// WEBPACK FOOTER //
// ./src/admin/institutions/create.js